module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "uk-card uk-card-default uk-card-small uk-card-hover tm-item-card"
  }, [_c('div', {
    staticClass: "uk-card-body"
  }, [_c('div', {
    staticClass: "tm-item-card-image"
  }, [_c('a', {
    staticClass: "tm-image-link uk-position-relative",
    attrs: {
      "href": _vm.ShopItem.href
    }
  }, [(_vm.image.src) ? _c('img', {
    attrs: {
      "src": _vm.image.src
    }
  }) : _c('div', {
    staticClass: "tm-no-image uk-flex uk-flex-column uk-flex-center uk-flex-middle"
  }, [_c('span', {
    staticClass: "uk-icon uk-margin-xsmall-right",
    attrs: {
      "uk-icon": "icon: image;ratio: 2;"
    }
  }), _vm._v(" "), _c('span', [_vm._v("No image")])])])]), _vm._v(" "), _c('div', {
    staticClass: "tm-item-card-info"
  }, [_c('div', {
    staticClass: "tm-item-card-info-header"
  }, [_c('a', {
    staticClass: "tm-item-card-title",
    attrs: {
      "href": _vm.ShopItem.href
    }
  }, [_vm._v(_vm._s(_vm.ShopItem.name))]), _vm._v(" "), _c('div', {
    staticClass: "tm-item-card-description"
  }, [_c('product-properties', {
    attrs: {
      "properties": _vm.ShopItemProperties
    }
  })], 1)])])]), _vm._v(" "), (_vm.hasSpecialTag === true) ? _c('div', {
    staticClass: "tm-tags-card"
  }, _vm._l((_vm.ShopItemTags), function(tag) {
    return _c('div', {
      staticClass: "uk-grid uk-grid-small uk-grid-stack"
    }, [(tag.ShopItemTag.id == 4) ? _c('div', {
      staticClass: "uk-grid-margin"
    }, [_c('a', {
      staticClass: "tm-tag-item tm-new-product-default",
      attrs: {
        "href": tag.ShopItemTag.href,
        "target": "_blank",
        "title": "Новинки"
      }
    }, [(tag.ShopItemTag.image) ? _c('img', {
      staticClass: "tm-tag-item-img",
      attrs: {
        "src": tag.ShopItemTag.image.src,
        "alt": "Новинка"
      }
    }) : _c('span', [_vm._v("Новинка")])])]) : _vm._e(), _vm._v(" "), (tag.ShopItemTag.id == 1) ? _c('div', {
      staticClass: "uk-grid-margin"
    }, [_c('a', {
      staticClass: "tm-tag-item tm-hot-commodity-default",
      attrs: {
        "href": tag.ShopItemTag.href,
        "target": "_blank",
        "title": "Популярные товары"
      }
    }, [(tag.ShopItemTag.image) ? _c('img', {
      staticClass: "tm-tag-item-img",
      attrs: {
        "src": tag.ShopItemTag.image.src,
        "alt": "Популярный товар"
      }
    }) : _c('span', [_vm._v("Популярный товар")])])]) : _vm._e(), _vm._v(" "), (tag.ShopItemTag.id == 3) ? _c('div', {
      staticClass: "uk-grid-margin"
    }, [_c('a', {
      staticClass: "tm-tag-item tm-sale-default",
      attrs: {
        "href": tag.ShopItemTag.href,
        "target": "_blank",
        "title": "Распродажа"
      }
    }, [(tag.ShopItemTag.image) ? _c('img', {
      staticClass: "tm-tag-item-img",
      attrs: {
        "src": tag.ShopItemTag.image.src,
        "alt": "Распродажа"
      }
    }) : _c('span', [_vm._v("Распродажа")])])]) : _vm._e()])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "uk-card-footer"
  }, [_c('product-prices', _vm._g({
    attrs: {
      "shop-order-item": _vm.ShopOrderItem,
      "shop-item": _vm.ShopItem,
      "product-prices": _vm.ShopItemPrices,
      "related-shop-items": _vm.RelatedShopItems,
      "shop-item-warehouses": _vm.ShopItemWarehouses
    }
  }, _vm.$listeners))], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21279a04","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/shop/Product/Product.vue
// module id = 50
// module chunks = 0